import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import {
  getPracticas,
  postPracticasPresupuesto,
  setActiveStep,
  setShowForm,
} from "../../../actions/autorizaciones/Autorizaciones";
import {
  PRACTICA_INSUMOS_AUTORIZACIONES,
  STEPPER_AUTORIZACIONES,
} from "../../../utils/constants";
import { AutorizacionesCard } from "../UI/AutorizacionesCard";
import { AutorizacionesAddPractica } from "./AutorizacionesAddPractica";
import { startAlerta } from "../../../actions/ui/alertas";
import { PresupuestosPractica } from "./PresupuestosPractica";

export const AutorizacionesPresupuestos = (props) => {
  const dispatch = useDispatch();

  const { practicas = [], presupuestoSeleccionado = {} } = useSelector(
    (state) => state.autorizaciones
  );

  
  const practicaDefault = (soloMateriales) => {
    if (soloMateriales) {
      return {
        idPresupuesto: presupuestoSeleccionado.idPresupuesto,
        cant: 1,
        idCodNom: PRACTICA_INSUMOS_AUTORIZACIONES.ID_COD_NOM,
        practica: {
          codNom: PRACTICA_INSUMOS_AUTORIZACIONES.COD_NOM,
          desNom: PRACTICA_INSUMOS_AUTORIZACIONES.DES_NOM,
        },
        recuperoSur: false,
        valorUnitario: 0
      };
    } else {
      return {};
    }
  }

  useEffect(() => {
    const practica = practicaDefault(presupuestoSeleccionado.soloMateriales);
    const agregaPracticaDefault = presupuestoSeleccionado.soloMateriales;
    dispatch(getPracticas(presupuestoSeleccionado.idTipoSolicitud, agregaPracticaDefault, practica));
  }, [dispatch]);

  const avanzarPantalla = () => {
    dispatch(setActiveStep(STEPPER_AUTORIZACIONES.CONFIRMACION));
  };

  const onClickSiguienteHandler = () => {
    if (
      practicas.length === 0
    ) {
      dispatch(
        startAlerta(
          `Debe agregar una práctica para continuar.`,
          "error"
        )
      );
    } else {
      const practicasFormateadas = practicas.map((practica) => {
        const materialesFormateados = practica.materiales?.map((material) => {
          return {
            idMaterial: material.idMaterial,
            cant: material.cantidad,
            valorUnitario: material.valorUnitario,
            recuperoSur: material.recuperoSur,
          };
        });

        return {
          idPresupuesto: practica.idPresupuesto || presupuestoSeleccionado?.idPresupuesto,
          idCodNom: practica.idCodNom,
          cant: practica.cant,
          valorUnitario: practica.valorUnitario,
          materiales: materialesFormateados ? materialesFormateados : [],
          // idTipoSolicitud: presupuestoSeleccionado.idTipoSolicitud,
        };
      });

      dispatch(
        postPracticasPresupuesto({ practicas: practicasFormateadas }, avanzarPantalla)
      );
    }
  };

  return (
    <AutorizacionesCard width={"75%"} >
      {!presupuestoSeleccionado.soloMateriales && <AutorizacionesAddPractica idTipoSolicitud={presupuestoSeleccionado.idTipoSolicitud} />}
      {practicas.map((practica, index) => {
        return <PresupuestosPractica key={index} practica={practica} />;
      })}
      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{ marginRight: "3rem" }}
          onClick={() => {
            dispatch(setActiveStep(STEPPER_AUTORIZACIONES.DETALLES_ORDEN));
            dispatch(setShowForm(false));
          }}
        >
          Anterior
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClickSiguienteHandler}
        >
          Siguiente
        </Button>
      </div>
    </AutorizacionesCard>
  );
};
